// import React, { useEffect, useState } from "react";
// import {
//   AppBar,
//   Avatar,
//   Box,
//   Button,
//   ButtonGroup,
//   CssBaseline,
//   DialogTitle,
//   Divider,
//   Grid,
//   IconButton,
//   InputAdornment,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Menu,
//   Drawer,
//   MenuItem,
//   Toolbar,
//   Typography,
//   Collapse,
//   TextField,
// } from "@mui/material";
// import { Link, useNavigate } from "react-router-dom";
// import { styled } from '@mui/system';
// import { useCookies } from "react-cookie";
// import CloseIcon from "@mui/icons-material/Close";
// import AddIcon from "@mui/icons-material/Add";
// import MinimizeIcon from "@mui/icons-material/Minimize";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
// import MenuIcon from "@mui/icons-material/Menu";
// import SearchIcon from "@mui/icons-material/Search";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import { config } from "../../config/config";
// import { Logout, PersonAdd } from "@mui/icons-material";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import {
//   indiaTopCities,
//   MenuServices,
//   propertyTypesDetails,
// } from "../../common/common";
// import { useDispatch, useSelector } from "react-redux";
// import { getCities, getLocation } from "../../global/redux/action";
// import UseBreakpoints from "./../custom-hook/UseBreakpoints";
// import NavBar from "./NavBar";
// import { useDebounce } from "../custom-hook/useDebounce";
// import { useMenuItems } from "./dashboard/NavPermissionUtils";
// import { apiList, invokeApi } from "../../apis/apiServices";

// const StickyHeader = styled(AppBar)({
//   position: "sticky",
//   top: 0,
//   backgroundColor: "#000", // White background
//   boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Light shadow
//   zIndex: 1000, // Ensures it stays above other content
// });

// const Header = () => {
//   const { medium, large, extraLarge } = UseBreakpoints();
//   const menuItems = useMenuItems();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [cookies, setCookies] = useCookies();

//   const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);
//   const [addressDrawer, setAddressDrawer] = useState(false);

//   const [searchCity, setSearchCity] = useState("");
//   const debounceSearch = useDebounce(searchCity, 500);
//   const [filteredCitiesList, setFilteredCitiesList] = useState([]);

//   const [mobileServiceDrawer, setMobileServiceDrawer] = useState(false);
//   const [mobileforBuyersMenu, setMobileforBuyersMenu] = useState(false);
//   const [mobileforTenantsMenu, setMobileforTenantsMenu] = useState(false);
//   const [mobileforOwnersMenu, setMobileforOwnersMenu] = useState(false);

//   // User Data
//   const { userData, userError } = useSelector(
//     (state) => state.user
//   );

//   // Location Data
//   const { locationData, locationError, isLocationFetching } = useSelector(
//     (state) => state.location
//   );

//   // Cities Data
//   const { citiesData, citiesError, isCitiesFetching } = useSelector(
//     (state) => state.cities
//   );

//   useEffect(() => {
//     if (locationError) {
//       alert(
//         "Something went wrong while fetching Location details. Please try again later!"
//       );
//     }
//     if (citiesError) {
//       alert(
//         "Something went wrong while fetching Cities details. Please try again later!"
//       );
//     }
//   }, [locationError, citiesError]);

//   useEffect(() => {
//     if (!locationData?.countries && !isLocationFetching && !locationError) {
//       dispatch(
//         getLocation({ id: cookies[config.cookieName]?.loginUserId, cookies })
//       );
//     }
//     if (!citiesData?.cities && !isCitiesFetching && !citiesError) {
//       dispatch(
//         getCities({ id: cookies[config.cookieName]?.loginUserId, cookies })
//       );
//     }
//   }, [
//     dispatch,
//     cookies,
//     locationError,
//     locationData,
//     isLocationFetching,
//     isCitiesFetching,
//     citiesError,
//     citiesData
//   ]);

//   const handleSearchCityChange = (event) => {
//     const value = event.target.value.toLowerCase();
//     setSearchCity(value);
//   };

//   const handleOpenServiceDrawer = () => {
//     setMobileServiceDrawer((open) => !open);
//   };

//   const handleMenuDrawer = () => {
//     setIsMenuDrawerOpen((editing) => !editing);
//   };
//   const handleAddressDrawer = () => {
//     setAddressDrawer((editing) => !editing);
//   };

//   // open menu
//   const [anchorElProfileMenu, setAnchorElProfileMenu] = useState(null);
//   const openProfileMenu = Boolean(anchorElProfileMenu);

//   const handleOpenProfileMenu = (event) => {
//     setAnchorElProfileMenu(event.currentTarget);
//   };

//   const handleCloseProfileMenu = () => {
//     setAnchorElProfileMenu(null);
//   };

//   const setCity = (value) => {
//     // Create updated cookie value
//     const updatedCookieValue = JSON.stringify({
//       ...cookies[config.preferencesCookie],
//       city: value,
//     });

//     setCookies(config.preferencesCookie, updatedCookieValue, {
//       path: "/",
//       maxAge: 3000000,
//       sameSite: "strict",
//     });
//   };

//   useEffect(() => {
//     if (!cookies[config.preferencesCookie]?.listingType) {
//       setCookies(
//         config.preferencesCookie,
//         JSON.stringify({
//           ...cookies[config.preferencesCookie],
//           listingType: propertyTypesDetails[0].listingType,
//           buildingType: null,
//           propertyType: null,
//           minPrice: null,
//           maxPrice: null,
//           minSize: null,
//           maxSize: null,
//           country: "India",
//           city: "Bangalore",
//           postedOn: null,
//           amenities: [],
//           furnishType: null,
//           facing: [],
//           bhk: [],
//           searchCity: null,
//           possessionStatus: null,
//         }),
//         { path: "/", maxAge: 3000000, sameSite: "strict" }
//       );
//     }
//   }, [cookies]);

//   useEffect(() => {
//     if (debounceSearch) {
//       const filtered = citiesData?.cities.filter((city) =>
//         city.toLowerCase().includes(searchCity)
//       );
//       setFilteredCitiesList(filtered);
//     }
//   }, [debounceSearch]);

//   const handleCookieListingType = (value) => {
//     // Create updated cookie value
//     const updatedCookieValue = JSON.stringify({
//       ...cookies[config.preferencesCookie],
//       listingType: value,
//     });

//     setCookies(config.preferencesCookie, updatedCookieValue, {
//       path: "/",
//       maxAge: 3000000,
//       sameSite: "strict",
//     });

//     navigate("/property/" + value.toLowerCase());
//     handleMenuDrawer();
//   };

//   useEffect(() => {
//     if (userError) {
//       alert(
//         "Something went wrong while fetching user details. Please try again later!"
//       );
//     }
//   }, [userError])

//   return (
//     <>
//       <CssBaseline />
//       <StickyHeader>
//         <Toolbar>
//           <Grid container alignItems="center">
//             {!medium && !large && !extraLarge ? (
//               <>
//                 <Grid item xs={3}>
//                   <IconButton
//                     color="inherit"
//                     edge="start"
//                     aria-label="menu"
//                     onClick={handleMenuDrawer}
//                   >
//                     <MenuIcon />
//                   </IconButton>
//                 </Grid>
//                 <Grid item xs={5} sx={{ textAlign: "center" }}>
//                   <Box
//                     component={"img"}
//                     src="/getmyhousing.png"
//                     height={"50px"}
//                     sx={{ my: 1, cursor: "pointer" }}
//                     onClick={() => {
//                       navigate("/");
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={4} sx={{ textAlign: "center" }}>
//                   {/* Render city menu for mobile */}
//                   <Button
//                     color="inherit"
//                     endIcon={<KeyboardArrowDownIcon />}
//                     onClick={handleAddressDrawer}
//                     sx={{ fontSize: "15px" }}
//                   >
//                     City
//                   </Button>
//                 </Grid>
//               </>
//             ) : (
//               <>
//                 <Grid item md={2}>
//                   <Box
//                     sx={{
//                       cursor: "pointer",
//                       my: 1,
//                     }}
//                     onClick={() => {
//                       navigate("/");
//                     }}
//                   >
//                     {/* Get My Housing */}

//                     <img src="/getmyhousing.png" height="80px" />
//                   </Box>
//                 </Grid>
//                 <Grid item md={8}>
//                   <NavBar />
//                 </Grid>
//                 <Grid
//                   item
//                   md={2}
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: "10px",
//                     flexDirection: "column",
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontSize: { md: "0.7rem", lg: "0.9rem", xl: "1.1rem" },
//                     }}
//                   >
//                     Enquiry Now : {config.mobileNumber1}
//                   </Typography>
//                   {cookies[config.cookieName]?.token &&
//                     cookies[config.cookieName]?.loginUserId ? (
//                     <>
//                       <IconButton
//                         onClick={handleOpenProfileMenu}
//                         size="small"
//                         sx={{ ml: 2 }}
//                         aria-controls={
//                           anchorElProfileMenu ? "account-menu" : undefined
//                         }
//                         aria-haspopup="true"
//                         aria-expanded={anchorElProfileMenu ? "true" : undefined}
//                       >
//                         <Avatar
//                           sx={{
//                             width: 32,
//                             height: 32,
//                             textTransform: "uppercase",
//                           }}
//                         >
//                           {userData?.user?.fullName[0]}
//                         </Avatar>
//                       </IconButton>
//                       <Menu
//                         anchorEl={anchorElProfileMenu}
//                         id="account-menu"
//                         open={openProfileMenu}
//                         onClose={handleCloseProfileMenu}
//                         onClick={handleCloseProfileMenu}
//                         PaperProps={{
//                           elevation: 0,
//                           sx: {
//                             overflow: "visible",
//                             filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
//                             mt: 1.5,
//                             "& .MuiAvatar-root": {
//                               width: 32,
//                               height: 32,
//                               ml: -0.5,
//                               mr: 1,
//                             },
//                             "&:before": {
//                               content: '""',
//                               display: "block",
//                               position: "absolute",
//                               top: 0,
//                               right: 14,
//                               width: 10,
//                               height: 10,
//                               bgcolor: "background.paper",
//                               transform: "translateY(-50%) rotate(45deg)",
//                               zIndex: 0,
//                             },
//                           },
//                         }}
//                         transformOrigin={{
//                           horizontal: "right",
//                           vertical: "top",
//                         }}
//                         anchorOrigin={{
//                           horizontal: "right",
//                           vertical: "bottom",
//                         }}
//                       >
//                         {userData?.user?.roles.includes("Customer") ? (
//                           <MenuItem
//                             onClick={() => {
//                               navigate("/my-profile");
//                               handleCloseProfileMenu();
//                             }}
//                           >
//                             <ListItemIcon>
//                               <AccountCircleIcon fontSize="small" />
//                             </ListItemIcon>
//                             My Profile
//                           </MenuItem>
//                         ) : (
//                           <MenuItem
//                             onClick={() => {
//                               navigate(menuItems[0].path);
//                               handleCloseProfileMenu();
//                             }}
//                           >
//                             <ListItemIcon>
//                               <PersonAdd fontSize="small" />
//                             </ListItemIcon>
//                             DashBoard
//                           </MenuItem>
//                         )}

//                         <Divider />
//                         <MenuItem
//                           onClick={() => {
//                             handleCloseProfileMenu();
//                             navigate("/logout");
//                           }}
//                         >
//                           <ListItemIcon>
//                             <Logout fontSize="small" />
//                           </ListItemIcon>
//                           Logout
//                         </MenuItem>
//                       </Menu>
//                     </>
//                   ) : (
//                     <ButtonGroup
//                       variant="outlined"
//                       aria-label="outlined button group"
//                       sx={{
//                         flexDirection: { sm: "row", xs: "column" }, // Set to column under 600px
//                       }}
//                     >
//                       <Button
//                         variant="outlined"
//                         sx={{
//                           color: "white",
//                           borderColor: "#fff",
//                           background: "red",
//                           "&:hover": {
//                             background: "var(--BG-Color-5, #F8F8F8)",
//                             color: "#DB282F",
//                           },
//                         }}
//                         size="small"
//                         onClick={() => navigate("/login")}
//                       >
//                         Login
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         sx={{
//                           color: "white",
//                           borderColor: "#fff",
//                           background: "red",
//                           "&:hover": {
//                             background: "var(--BG-Color-5, #F8F8F8)",
//                             color: "#DB282F",
//                           },
//                         }}
//                         onClick={() => navigate("/contact-us")}
//                         size="small"
//                       >
//                         Enquiry
//                       </Button>
//                     </ButtonGroup>
//                   )}
//                 </Grid>
//               </>
//             )}
//           </Grid>
//         </Toolbar>
//       </StickyHeader>
//       {/* mobile Menu Drawer */}
//       <Drawer
//         open={isMenuDrawerOpen}
//         onClose={handleMenuDrawer}
//         PaperProps={{
//           sx: { width: "100%" },
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             px: 2,
//           }}
//         >
//           <DialogTitle
//             sx={{
//               fontWeight: "bold",
//               fontSize: "15px",
//               textTransform: "uppercase",
//             }}
//           >
//             Get My Housing
//           </DialogTitle>
//           <IconButton onClick={handleMenuDrawer}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//         <Divider />
//         <List>
//           <ListItem>
//             <ListItemButton
//               onClick={() => {
//                 handleCookieListingType("Buy");
//               }}
//             >
//               <Typography>Home</Typography>
//               <IconButton size="small" sx={{ marginLeft: "auto" }}>
//                 <KeyboardArrowRightIcon />
//               </IconButton>
//             </ListItemButton>
//           </ListItem>
//           <ListItem>
//             <ListItemButton
//               onClick={() => {
//                 handleCookieListingType("Buy");
//               }}
//             >
//               <Typography>Buy</Typography>
//               <IconButton size="small" sx={{ marginLeft: "auto" }}>
//                 <KeyboardArrowRightIcon />
//               </IconButton>
//             </ListItemButton>
//           </ListItem>
//           <ListItem>
//             <ListItemButton
//               onClick={() => {
//                 handleCookieListingType("Rent");
//               }}
//             >
//               <Typography>Rent</Typography>
//               <IconButton size="small" sx={{ marginLeft: "auto" }}>
//                 <KeyboardArrowRightIcon />
//               </IconButton>
//             </ListItemButton>
//           </ListItem>
//           <ListItem>
//             <ListItemButton onClick={handleOpenServiceDrawer}>
//               <Typography>Services</Typography>
//               <IconButton size="small" sx={{ marginLeft: "auto" }}>
//                 <KeyboardArrowRightIcon />
//               </IconButton>
//             </ListItemButton>
//           </ListItem>
//           <ListItem>
//             <ListItemButton
//               onClick={() => {
//                 handleMenuDrawer();
//                 navigate("/about-us");
//               }}
//             >
//               <Typography>About Us</Typography>
//               <IconButton size="small" sx={{ marginLeft: "auto" }}>
//                 <KeyboardArrowRightIcon />
//               </IconButton>
//             </ListItemButton>
//           </ListItem>

//           <ListItem>
//             <ListItemButton
//               onClick={() => {
//                 handleMenuDrawer();
//                 navigate("/contact-us");
//               }}
//             >
//               <Typography>Contact Us</Typography>
//               <IconButton size="small" sx={{ marginLeft: "auto" }}>
//                 <KeyboardArrowRightIcon />
//               </IconButton>
//             </ListItemButton>
//           </ListItem>
//         </List>
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: "0px",
//             left: "50%",
//             transform: "translate(-50%, 0%)",
//             py: 2,
//             boxShadow: "0px 14px 10px 10px #777",
//             width: "100%",
//           }}
//         >
//           <Box sx={{ display: "flex", justifyContent: "center", gap: "20px" }}>
//             {!cookies[config.cookieName]?.token &&
//               !cookies[config.cookieName]?.loginUserId ? (
//               <>
//                 <Link
//                   to={"/login"}
//                   style={{
//                     padding: "10px 21px",
//                     borderRadius: "25px",
//                     backgroundColor: "rgb(119 119 119 / 40%)",
//                     color: "#000",
//                     textDecoration: "none",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Login
//                 </Link>
//                 <Link
//                   to={"/contact-us"}
//                   style={{
//                     padding: "10px 21px",
//                     borderRadius: "25px",
//                     backgroundColor: "rgb(119 119 119 / 40%)",
//                     color: "#000",
//                     textDecoration: "none",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Enquiry
//                 </Link>
//               </>
//             ) : (
//               <>
//                 <Link
//                   to={"/post-property"}
//                   style={{
//                     padding: "10px 21px",
//                     borderRadius: "25px",
//                     backgroundColor: "rgb(119 119 119 / 40%)",
//                     color: "#000",
//                     textDecoration: "none",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Dashboard
//                 </Link>
//                 <Link
//                   to={"/logout"}
//                   style={{
//                     padding: "10px 21px",
//                     borderRadius: "25px",
//                     backgroundColor: "rgb(119 119 119 / 40%)",
//                     color: "#000",
//                     textDecoration: "none",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Logout
//                 </Link>
//               </>
//             )}
//           </Box>
//           <Box
//             sx={{
//               width: "100%",
//               display: "block",
//               textAlign: "center",
//               py: 2,
//               fontWeight: "700",
//               fontSize: "1.1rem",
//             }}
//           >
//             <Typography>Enquiry Now: {config.mobileNumber1}</Typography>
//           </Box>
//         </Box>
//       </Drawer >

//       {/* Address Drawer */}
//       <Drawer
//         open={addressDrawer}
//         onClose={handleAddressDrawer}
//         anchor="right"
//         PaperProps={{
//           sx: { width: "100%" },
//         }
//         }
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             px: 2,
//           }}
//         >
//           <IconButton onClick={handleAddressDrawer}>
//             <ArrowBackIcon />
//           </IconButton>
//         </Box>
//         <Divider />
//         <List>
//           <ListItem>
//             <TextField
//               variant="outlined"
//               placeholder="Search"
//               size="small"
//               fullWidth
//               value={searchCity || ""}
//               onChange={handleSearchCityChange}
//               sx={{ backgroundColor: "#EFEFEF", width: "100%" }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </ListItem>
//           <ListItem
//             sx={{
//               cursor: "default",
//               fontWeight: "bold",
//             }}
//           >
//             <ListItemText
//               primary="Top Cities"
//               sx={{
//                 fontSize: "15px",
//                 textDecoration: "underline",
//               }}
//             />
//           </ListItem>
//           {!searchCity && !debounceSearch ? (
//             <>
//               <Box
//                 sx={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr 1fr",
//                   px: "15px",
//                   columnGap: "10px",
//                 }}
//               >
//                 {indiaTopCities.map((city) => (
//                   <Box
//                     key={city.name}
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       border: "1px solid gray",
//                       borderRadius: "5px",
//                       my: "10px",
//                       p: "8px",
//                       cursor: "pointer",
//                     }}
//                     onClick={() => {
//                       setCity(city.name);
//                       // handleCloseMenu("City");
//                       setAddressDrawer(false);
//                     }}
//                   >
//                     <img src={city.svg} height="30px" alt="cities" />
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         "&:hover": { color: "blue" },
//                       }}
//                     >
//                       {city.name}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>
//               {citiesData?.cities.map((item) => (
//                 <ListItem key={item} button onClick={() => setCity(item)}>
//                   <ListItemText primary={item} />
//                 </ListItem>
//               ))}
//             </>
//           ) : (
//             filteredCitiesList.map((item) => (
//               <ListItem key={item} button onClick={() => setCity(item)}>
//                 <ListItemText primary={item} />
//               </ListItem>
//             ))
//           )}
//         </List>
//       </Drawer>

//       {/* Services List Drawer */}
//       < Drawer
//         open={mobileServiceDrawer}
//         onClose={handleOpenServiceDrawer}
//         anchor="right"
//         PaperProps={{
//           sx: { width: "100%" },
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             px: 2,
//           }}
//         >
//           <IconButton onClick={handleOpenServiceDrawer}>
//             <ArrowBackIcon />
//           </IconButton>
//           <Typography>Services</Typography>
//         </Box>
//         <Divider />
//         <List component="nav">
//           <ListItem
//             button
//             onClick={() => setMobileforBuyersMenu(!mobileforBuyersMenu)}
//           >
//             <ListItemText primary="For Buyers" />
//             {mobileforBuyersMenu ? <MinimizeIcon /> : <AddIcon />}
//           </ListItem>
//           <Collapse in={mobileforBuyersMenu} timeout="auto" unmountOnExit>
//             <List component="div">
//               {MenuServices.forBuyers?.map((item, index) => (
//                 <ListItem
//                   button
//                   style={{ paddingLeft: "16px" }}
//                   key={index}
//                   onClick={() => {
//                     // handleCloseMenu("Services");
//                     navigate(
//                       item.navigate + cookies[config.preferencesCookie]?.city
//                     );
//                   }}
//                 >
//                   <ListItemText primary={item.name} />
//                 </ListItem>
//               ))}
//               {/* Add more sub-menu items as needed */}
//             </List>
//           </Collapse>
//           <ListItem
//             button
//             onClick={() => setMobileforTenantsMenu(!mobileforTenantsMenu)}
//           >
//             <ListItemText primary="For Tenants" />
//             {mobileforTenantsMenu ? <MinimizeIcon /> : <AddIcon />}
//           </ListItem>
//           <Collapse in={mobileforTenantsMenu} timeout="auto" unmountOnExit>
//             <List component="div">
//               {MenuServices.forTenants?.map((item, index) => (
//                 <ListItem
//                   button
//                   style={{ paddingLeft: "16px" }}
//                   key={index}
//                   onClick={() => {
//                     // handleCloseMenu("Services");
//                     navigate(
//                       item.navigate + cookies[config.preferencesCookie]?.city
//                     );
//                   }}
//                 >
//                   <ListItemText primary={item.name} />
//                 </ListItem>
//               ))}
//               {/* Add more sub-menu items as needed */}
//             </List>
//           </Collapse>
//           <ListItem
//             button
//             onClick={() => setMobileforOwnersMenu(!mobileforOwnersMenu)}
//           >
//             <ListItemText primary="For Owners" />
//             {mobileforOwnersMenu ? <MinimizeIcon /> : <AddIcon />}
//           </ListItem>
//           <Collapse in={mobileforOwnersMenu} timeout="auto" unmountOnExit>
//             <List component="div">
//               {MenuServices.forOwners?.map((item, index) => (
//                 <ListItem
//                   button
//                   style={{ paddingLeft: "16px" }}
//                   key={index}
//                   onClick={() => {
//                     // handleCloseMenu("Services");
//                     navigate(
//                       item.navigate + cookies[config.preferencesCookie]?.city
//                     );
//                   }}
//                 >
//                   <ListItemText primary={item.name} />
//                 </ListItem>
//               ))}
//               {/* Add more sub-menu items as needed */}
//             </List>
//           </Collapse>
//         </List>
//       </Drawer >
//     </>
//   );
// };

// export default Header;
























import React, { useEffect, useState } from "react";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  ButtonGroup,
  CssBaseline,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Drawer,
  MenuItem,
  Toolbar,
  Typography,
  Collapse,
  TextField,
  Container,
  Badge,
  Fade,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { styled, alpha } from '@mui/material/styles';
import { useCookies } from "react-cookie";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import MinimizeIcon from "@mui/icons-material/Minimize";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";
import InfoIcon from "@mui/icons-material/Info";
import EmailIcon from "@mui/icons-material/Email";
import { config } from "../../config/config";
import { Logout, PersonAdd } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  indiaTopCities,
  MenuServices,
  propertyTypesDetails,
} from "../../common/common";
import { useDispatch, useSelector } from "react-redux";
import { getCities, getLocation } from "../../global/redux/action";
import UseBreakpoints from "./../custom-hook/UseBreakpoints";
import NavBar from "./NavBar";
import { useDebounce } from "../custom-hook/useDebounce";
import { useMenuItems } from "./dashboard/NavPermissionUtils";

// Styled Components
const StickyHeader = styled(AppBar)(({ theme }) => ({
  position: "sticky",
  top: 0,
  background: "linear-gradient(135deg, #000000 0%, #1a1a2e 100%)",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)",
  zIndex: 1200,
  borderBottom: "3px solid #DB282F",
  transition: "all 0.3s ease-in-out",
  height: { xs: "70px", sm: "75px", md: "80px", lg: "85px" },
  display: "flex",
  justifyContent: "center",
}));

const GlassCard = styled(Box)(({ theme }) => ({
  background: alpha(theme.palette.common.white, 0.08),
  backdropFilter: "blur(10px)",
  borderRadius: "10px",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  padding: theme.spacing(1),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(1.5),
  },
}));

const GradientButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(135deg, #DB282F 0%, #C21820 100%)",
  color: "#fff",
  borderRadius: "6px",
  fontWeight: 600,
  textTransform: "none",
  padding: "6px 16px",
  fontSize: "0.875rem",
  transition: "all 0.3s ease",
  "&:hover": {
    background: "linear-gradient(135deg, #C21820 0%, #A81017 100%)",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(219, 40, 47, 0.4)",
  },
  "&.Mui-disabled": {
    background: "rgba(255, 255, 255, 0.12)",
  },
}));

const CityChip = styled(Chip)(({ theme }) => ({
  background: "rgba(255, 255, 255, 0.08)",
  color: "#fff",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "20px",
  fontWeight: 500,
  fontSize: "0.75rem",
  height: "32px",
  "&:hover": {
    background: "rgba(219, 40, 47, 0.5)",
    borderColor: "#DB282F",
  },
  "& .MuiChip-icon": {
    color: "#DB282F",
    marginLeft: "4px",
  },
}));

const DrawerHeader = styled(Box)(({ theme }) => ({
  background: "linear-gradient(135deg, #DB282F 0%, #C21820 100%)",
  padding: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "64px",
}));

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  const menuItems = useMenuItems();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cookies, setCookies] = useCookies();

  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);
  const [addressDrawer, setAddressDrawer] = useState(false);
  const [searchCity, setSearchCity] = useState("");
  const debounceSearch = useDebounce(searchCity, 500);
  const [filteredCitiesList, setFilteredCitiesList] = useState([]);
  const [mobileServiceDrawer, setMobileServiceDrawer] = useState(false);
  const [mobileforBuyersMenu, setMobileforBuyersMenu] = useState(false);
  const [mobileforTenantsMenu, setMobileforTenantsMenu] = useState(false);
  const [mobileforOwnersMenu, setMobileforOwnersMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // User Data
  const { userData, userError } = useSelector((state) => state.user);
  // Location Data
  const { locationData, locationError, isLocationFetching } = useSelector(
    (state) => state.location
  );
  // Cities Data
  const { citiesData, citiesError, isCitiesFetching } = useSelector(
    (state) => state.cities
  );

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (locationError || citiesError) {
      console.error("Error fetching data:", locationError || citiesError);
    }
  }, [locationError, citiesError]);

  useEffect(() => {
    if (!locationData?.countries && !isLocationFetching && !locationError) {
      dispatch(
        getLocation({ id: cookies[config.cookieName]?.loginUserId, cookies })
      );
    }
    if (!citiesData?.cities && !isCitiesFetching && !citiesError) {
      dispatch(
        getCities({ id: cookies[config.cookieName]?.loginUserId, cookies })
      );
    }
  }, [
    dispatch,
    cookies,
    locationError,
    locationData,
    isLocationFetching,
    isCitiesFetching,
    citiesError,
    citiesData
  ]);

  const handleSearchCityChange = (event) => {
    const value = event.target.value;
    setSearchCity(value);
  };

  const handleOpenServiceDrawer = () => {
    setMobileServiceDrawer(!mobileServiceDrawer);
  };

  const handleMenuDrawer = () => {
    setIsMenuDrawerOpen(!isMenuDrawerOpen);
  };

  const handleAddressDrawer = () => {
    setAddressDrawer(!addressDrawer);
  };

  const [anchorElProfileMenu, setAnchorElProfileMenu] = useState(null);
  const openProfileMenu = Boolean(anchorElProfileMenu);

  const handleOpenProfileMenu = (event) => {
    setAnchorElProfileMenu(event.currentTarget);
  };

  const handleCloseProfileMenu = () => {
    setAnchorElProfileMenu(null);
  };

  const setCity = (value) => {
    const updatedCookieValue = JSON.stringify({
      ...cookies[config.preferencesCookie],
      city: value,
    });

    setCookies(config.preferencesCookie, updatedCookieValue, {
      path: "/",
      maxAge: 3000000,
      sameSite: "strict",
    });
    setAddressDrawer(false);
  };

  useEffect(() => {
    if (!cookies[config.preferencesCookie]?.listingType) {
      setCookies(
        config.preferencesCookie,
        JSON.stringify({
          ...cookies[config.preferencesCookie],
          listingType: propertyTypesDetails[0]?.listingType || "Buy",
          buildingType: null,
          propertyType: null,
          minPrice: null,
          maxPrice: null,
          minSize: null,
          maxSize: null,
          country: "India",
          city: "Bangalore",
          postedOn: null,
          amenities: [],
          furnishType: null,
          facing: [],
          bhk: [],
          searchCity: null,
          possessionStatus: null,
        }),
        { path: "/", maxAge: 3000000, sameSite: "strict" }
      );
    }
  }, [cookies, setCookies]);

  useEffect(() => {
    if (debounceSearch && citiesData?.cities) {
      const filtered = citiesData.cities.filter((city) =>
        city.toLowerCase().includes(debounceSearch.toLowerCase())
      );
      setFilteredCitiesList(filtered);
    } else {
      setFilteredCitiesList([]);
    }
  }, [debounceSearch, citiesData]);

  const handleCookieListingType = (value) => {
    const updatedCookieValue = JSON.stringify({
      ...cookies[config.preferencesCookie],
      listingType: value,
    });

    setCookies(config.preferencesCookie, updatedCookieValue, {
      path: "/",
      maxAge: 3000000,
      sameSite: "strict",
    });

    navigate("/property/" + value.toLowerCase());
    handleMenuDrawer();
  };

  useEffect(() => {
    if (userError) {
      console.error("User fetch error:", userError);
    }
  }, [userError]);

  const currentCity = cookies[config.preferencesCookie]?.city || "Bangalore";
  const isLoggedIn = cookies[config.cookieName]?.token && cookies[config.cookieName]?.loginUserId;

  // Mobile View
  if (isMobile) {
    return (
      <>
        <CssBaseline />
        <StickyHeader>
          <Toolbar sx={{ minHeight: "70px!important", px: 2 }}>
            <Grid container alignItems="center" justifyContent="space-between">
              {/* Menu Button */}
              <Grid item xs={3}>
                <IconButton
                  onClick={handleMenuDrawer}
                  sx={{
                    color: "#fff",
                    background: "rgba(255, 255, 255, 0.1)",
                    "&:hover": {
                      background: "rgba(219, 40, 47, 0.8)",
                    },
                    width: 40,
                    height: 40,
                  }}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>

              {/* Logo */}
              <Grid item xs={5} sx={{ textAlign: "center" }}>
                <Box
                  component="img"
                  src="/getmyhousing.png"
                  alt="Get My Housing"
                  sx={{
                    height: scrolled ? "35px" : "40px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                  onClick={() => navigate("/")}
                />
              </Grid>

              {/* City Selector */}
              <Grid item xs={4} sx={{ textAlign: "right" }}>
                <Button
                  onClick={handleAddressDrawer}
                  sx={{
                    color: "#fff",
                    textTransform: "none",
                    fontSize: "0.75rem",
                    minWidth: "auto",
                    padding: "6px 8px",
                    background: "rgba(219, 40, 47, 0.8)",
                    borderRadius: "6px",
                    "&:hover": {
                      background: "#DB282F",
                    },
                  }}
                  startIcon={<LocationOnIcon sx={{ fontSize: 16 }} />}
                >
                  {currentCity.length > 10 ? `${currentCity.substring(0, 10)}...` : currentCity}
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </StickyHeader>

        {/* Mobile Menu Drawer */}
        <Drawer
          anchor="left"
          open={isMenuDrawerOpen}
          onClose={handleMenuDrawer}
          PaperProps={{
            sx: {
              width: "100%",
              maxWidth: "100%",
              background: "linear-gradient(180deg, #0f0f23 0%, #1a1a2e 100%)",
              color: "#fff",
            },
          }}
        >
          <DrawerHeader>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <HomeIcon sx={{ color: "#fff" }} />
              <Typography variant="h6" sx={{ fontWeight: 600, color: "#fff" }}>
                Get My Housing™
              </Typography>
            </Box>
            <IconButton onClick={handleMenuDrawer} sx={{ color: "#fff" }}>
              <CloseIcon />
            </IconButton>
          </DrawerHeader>

          <List sx={{ px: 2, py: 1, overflow: "hidden" }}>
            {[
              { label: "Home", icon: <HomeIcon />, onClick: () => navigate("/") },
              { label: "Buy", icon: <ShoppingCartIcon />, onClick: () => handleCookieListingType("Buy") },
              { label: "Rent", icon: <BusinessIcon />, onClick: () => handleCookieListingType("Rent") },
              { label: "Services", icon: <ApartmentIcon />, onClick: handleOpenServiceDrawer },
              { label: "About Us", icon: <InfoIcon />, onClick: () => { handleMenuDrawer(); navigate("/about-us"); } },
              { label: "Contact Us", icon: <EmailIcon />, onClick: () => { handleMenuDrawer(); navigate("/contact-us"); } },
            ].map((item) => (
              <ListItem key={item.label} disablePadding sx={{ mb: 1 }}>
                <ListItemButton
                  onClick={item.onClick}
                  sx={{
                    borderRadius: "8px",
                    py: 1.5,
                    background: "rgba(255, 255, 255, 0.03)",
                    "&:hover": {
                      background: "rgba(219, 40, 47, 0.15)",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#DB282F", minWidth: 40 }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography sx={{ fontWeight: 500, fontSize: "0.95rem" }}>
                        {item.label}
                      </Typography>
                    }
                  />
                  <KeyboardArrowRightIcon sx={{ color: "rgba(255,255,255,0.5)" }} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          {/* Auth Buttons */}
          <Box sx={{ p: 3, mt: "auto", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
            <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              {!isLoggedIn ? (
                <>
                  <GradientButton
                    fullWidth
                    onClick={() => {
                      handleMenuDrawer();
                      navigate("/login");
                    }}
                  >
                    Login
                  </GradientButton>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                      handleMenuDrawer();
                      navigate("/contact-us");
                    }}
                    sx={{
                      borderColor: "#DB282F",
                      color: "#DB282F",
                      "&:hover": {
                        borderColor: "#FF6B6B",
                        background: "rgba(219, 40, 47, 0.1)",
                      },
                    }}
                  >
                    Enquiry
                  </Button>
                </>
              ) : (
                <>
                  <GradientButton
                    fullWidth
                    onClick={() => {
                      handleMenuDrawer();
                      navigate("/post-property");
                    }}
                  >
                    Dashboard
                  </GradientButton>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                      handleMenuDrawer();
                      navigate("/logout");
                    }}
                    sx={{
                      borderColor: "#DB282F",
                      color: "#DB282F",
                      "&:hover": {
                        borderColor: "#FF6B6B",
                        background: "rgba(219, 40, 47, 0.1)",
                      },
                    }}
                  >
                    Logout
                  </Button>
                </>
              )}
            </Box>

            {/* Contact Info */}
            <Box sx={{ textAlign: "center", pt: 2, borderTop: "1px solid rgba(255,255,255,0.1)" }}>
              <Typography sx={{ color: "#DB282F", fontWeight: 600, mb: 1, fontSize: "0.9rem" }}>
                <PhoneIcon sx={{ fontSize: 14, verticalAlign: "middle", mr: 1 }} />
                Enquiry Now
              </Typography>
              <Typography sx={{ color: "#fff", fontSize: "1rem", fontWeight: 700 }}>
                {config.mobileNumber1 || "+91 1234567890"}
              </Typography>
            </Box>
          </Box>
        </Drawer>

        {/* Address Drawer */}
        <Drawer
          anchor="right"
          open={addressDrawer}
          onClose={handleAddressDrawer}
          PaperProps={{
            sx: {
              width: "100%",
              maxWidth: "100%",
              background: "linear-gradient(180deg, #0f0f23 0%, #1a1a2e 100%)",
              color: "#fff",
            },
          }}
        >
          <DrawerHeader>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
              <IconButton onClick={handleAddressDrawer} sx={{ color: "#fff", mr: 1 }}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Select City
              </Typography>
            </Box>
          </DrawerHeader>

          <Box sx={{ p: 2, overflow: "hidden" }}>
            <TextField
              fullWidth
              placeholder="Search city..."
              value={searchCity}
              onChange={handleSearchCityChange}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  background: "rgba(255, 255, 255, 0.05)",
                  borderRadius: "8px",
                  "& fieldset": { borderColor: "rgba(255, 255, 255, 0.2)" },
                  "&:hover fieldset": { borderColor: "#DB282F" },
                  "&.Mui-focused fieldset": { borderColor: "#DB282F" },
                },
                "& .MuiInputBase-input": {
                  color: "#fff",
                  fontSize: "0.95rem",
                  padding: "12px 14px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#DB282F" }} />
                  </InputAdornment>
                ),
              }}
            />

            {/* Top Cities */}
            {!searchCity && (
              <>
                <Typography variant="subtitle1" sx={{ color: "#DB282F", fontWeight: 600, mb: 2, fontSize: "0.95rem" }}>
                  <LocationOnIcon sx={{ fontSize: 16, verticalAlign: "middle", mr: 1 }} />
                  Top Cities
                </Typography>
                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1, mb: 3 }}>
                  {indiaTopCities.slice(0, 9).map((city) => (
                    <CityChip
                      key={city.name}
                      icon={<img src={city.svg} alt={city.name} style={{ width: 16, height: 16 }} />}
                      label={city.name.length > 8 ? `${city.name.substring(0, 8)}...` : city.name}
                      onClick={() => setCity(city.name)}
                      sx={{ fontSize: "0.7rem" }}
                    />
                  ))}
                </Box>
              </>
            )}

            {/* All Cities */}
            <Typography variant="subtitle1" sx={{ color: "#DB282F", fontWeight: 600, mb: 2, fontSize: "0.95rem" }}>
              All Cities
            </Typography>
            <Box sx={{ maxHeight: "400px", overflowY: "auto", pr: 1 }}>
              {(searchCity ? filteredCitiesList : citiesData?.cities || []).slice(0, 50).map((city) => (
                <ListItemButton
                  key={city}
                  onClick={() => setCity(city)}
                  sx={{
                    mb: 0.5,
                    borderRadius: "6px",
                    py: 1.5,
                    background: currentCity === city ? "rgba(219, 40, 47, 0.15)" : "transparent",
                    "&:hover": {
                      background: "rgba(219, 40, 47, 0.1)",
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography sx={{ fontSize: "0.9rem", fontWeight: currentCity === city ? 600 : 400 }}>
                        {city}
                      </Typography>
                    }
                  />
                  {currentCity === city && (
                    <KeyboardArrowRightIcon sx={{ color: "#DB282F", fontSize: 20 }} />
                  )}
                </ListItemButton>
              ))}
            </Box>
          </Box>
        </Drawer>

        {/* Services Drawer */}
        <Drawer
          anchor="right"
          open={mobileServiceDrawer}
          onClose={handleOpenServiceDrawer}
          PaperProps={{
            sx: {
              width: "100%",
              maxWidth: "100%",
              background: "linear-gradient(180deg, #0f0f23 0%, #1a1a2e 100%)",
              color: "#fff",
            },
          }}
        >
          <DrawerHeader>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
              <IconButton onClick={handleOpenServiceDrawer} sx={{ color: "#fff", mr: 1 }}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Our Services
              </Typography>
            </Box>
          </DrawerHeader>

          <List sx={{ px: 2, py: 1 }}>
            {[
              {
                title: "For Buyers",
                open: mobileforBuyersMenu,
                setOpen: setMobileforBuyersMenu,
                items: MenuServices.forBuyers || [],
                icon: <ShoppingCartIcon />,
              },
              {
                title: "For Tenants",
                open: mobileforTenantsMenu,
                setOpen: setMobileforTenantsMenu,
                items: MenuServices.forTenants || [],
                icon: <BusinessIcon />,
              },
              {
                title: "For Owners",
                open: mobileforOwnersMenu,
                setOpen: setMobileforOwnersMenu,
                items: MenuServices.forOwners || [],
                icon: <ApartmentIcon />,
              },
            ].map((section) => (
              <React.Fragment key={section.title}>
                <ListItemButton
                  onClick={() => section.setOpen(!section.open)}
                  sx={{
                    borderRadius: "8px",
                    mb: 1,
                    py: 1.5,
                    background: section.open ? "rgba(219, 40, 47, 0.15)" : "rgba(255, 255, 255, 0.03)",
                    "&:hover": {
                      background: "rgba(219, 40, 47, 0.2)",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#DB282F", minWidth: 40 }}>
                    {section.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                        {section.title}
                      </Typography>
                    }
                  />
                  {section.open ? (
                    <MinimizeIcon sx={{ color: "#DB282F" }} />
                  ) : (
                    <AddIcon sx={{ color: "#DB282F" }} />
                  )}
                </ListItemButton>
                <Collapse in={section.open} timeout="auto" unmountOnExit>
                  <List sx={{ pl: 3 }}>
                    {section.items.map((item, index) => (
                      <ListItemButton
                        key={index}
                        onClick={() => {
                          navigate(item.navigate + currentCity);
                          handleOpenServiceDrawer();
                        }}
                        sx={{
                          pl: 4,
                          py: 1.25,
                          borderRadius: "6px",
                          mb: 0.5,
                          "&:hover": {
                            background: "rgba(219, 40, 47, 0.1)",
                          },
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography sx={{ fontSize: "0.875rem" }}>
                              {item.name}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </React.Fragment>
            ))}
          </List>
        </Drawer>
      </>
    );
  }

  // Desktop/Tablet View
  return (
    <>
      <CssBaseline />
      <StickyHeader>
        <Toolbar sx={{ minHeight: { md: "75px", lg: "85px" } }}>
          <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
            <Grid container alignItems="center" spacing={2}>
              {/* Logo */}
              <Grid item md={2} lg={2}>
                <Fade in={true}>
                  <Box
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                    }}
                    onClick={() => navigate("/")}
                  >
                    <img
                      src="/getmyhousing.png"
                      alt="Get My Housing"
                      style={{
                        height: scrolled ? "50px" : "55px",
                        transition: "all 0.3s ease",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Fade>
              </Grid>

              {/* Navigation */}
              <Grid item md={7} lg={7}>
                <NavBar />
              </Grid>

              {/* Right Section */}
              <Grid item md={3} lg={3}>
                <GlassCard>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    {/* Contact Info */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <PhoneIcon sx={{ color: "#DB282F", fontSize: { md: 16, lg: 18 } }} />
                      <Typography
                        sx={{
                          fontSize: { md: "0.75rem", lg: "0.85rem" },
                          fontWeight: 600,
                          color: "#fff",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {config.mobileNumber1 || "+91 1234567890"}
                      </Typography>
                    </Box>

                    {/* Auth Section */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {isLoggedIn ? (
                        <>
                          <IconButton
                            onClick={handleOpenProfileMenu}
                            size="small"
                            sx={{
                              width: 38,
                              height: 38,
                              background: "rgba(255, 255, 255, 0.1)",
                              "&:hover": {
                                background: "rgba(219, 40, 47, 0.8)",
                              },
                            }}
                          >
                            <Badge
                              badgeContent={1}
                              color="error"
                              variant="dot"
                            >
                              <Avatar
                                sx={{
                                  width: 32,
                                  height: 32,
                                  background: "linear-gradient(135deg, #DB282F 0%, #FF6B6B 100%)",
                                  fontWeight: "bold",
                                  fontSize: "0.9rem",
                                }}
                              >
                                {userData?.user?.fullName?.[0]?.toUpperCase() || "U"}
                              </Avatar>
                            </Badge>
                          </IconButton>
                          <Menu
                            anchorEl={anchorElProfileMenu}
                            open={openProfileMenu}
                            onClose={handleCloseProfileMenu}
                            PaperProps={{
                              sx: {
                                mt: 1.5,
                                background: "linear-gradient(135deg, #1a1a2e 0%, #0f0f23 100%)",
                                border: "1px solid rgba(219, 40, 47, 0.3)",
                                borderRadius: "8px",
                                minWidth: 180,
                                "& .MuiMenuItem-root": {
                                  color: "#fff",
                                  fontSize: "0.875rem",
                                  py: 1,
                                  "&:hover": {
                                    background: "rgba(219, 40, 47, 0.2)",
                                  },
                                },
                                "& .MuiDivider-root": {
                                  borderColor: "rgba(255,255,255,0.1)",
                                  my: 0.5,
                                },
                              },
                            }}
                          >
                            {userData?.user?.roles?.includes("Customer") ? (
                              <MenuItem
                                onClick={() => {
                                  navigate("/my-profile");
                                  handleCloseProfileMenu();
                                }}
                              >
                                <ListItemIcon sx={{ color: "#DB282F", minWidth: 36 }}>
                                  <AccountCircleIcon fontSize="small" />
                                </ListItemIcon>
                                My Profile
                              </MenuItem>
                            ) : (
                              <MenuItem
                                onClick={() => {
                                  navigate(menuItems[0]?.path || "/dashboard");
                                  handleCloseProfileMenu();
                                }}
                              >
                                <ListItemIcon sx={{ color: "#DB282F", minWidth: 36 }}>
                                  <PersonAdd fontSize="small" />
                                </ListItemIcon>
                                Dashboard
                              </MenuItem>
                            )}
                            <Divider />
                            <MenuItem
                              onClick={() => {
                                navigate("/logout");
                                handleCloseProfileMenu();
                              }}
                            >
                              <ListItemIcon sx={{ color: "#DB282F", minWidth: 36 }}>
                                <Logout fontSize="small" />
                              </ListItemIcon>
                              Logout
                            </MenuItem>
                          </Menu>
                        </>
                      ) : (
                        <ButtonGroup
                          variant="contained"
                          sx={{
                            "& .MuiButton-root": {
                              fontSize: "0.75rem",
                              px: 2,
                              py: 0.75,
                              minWidth: "auto",
                            },
                          }}
                        >
                          <GradientButton
                            onClick={() => navigate("/login")}
                            size="small"
                          >
                            Login
                          </GradientButton>
                          <GradientButton
                            onClick={() => navigate("/contact-us")}
                            size="small"
                            sx={{
                              // ml: 1,
                            }}
                          >
                            Enquiry
                          </GradientButton>
                        </ButtonGroup>
                      )}
                    </Box>
                  </Box>
                </GlassCard>
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </StickyHeader>
    </>
  );
};

export default Header;